import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'

window['global'] = window
import { ChatScreenSkeleton } from 'common/UI/LoadingSkeleton'
import { ThemeProvider } from 'common/contexts/themeContext/themeContext'
import ErrorBoundary from 'common/UI/ErrorBoundary'
import { lazyWithErrorHandling } from 'modules/Auth/store/lazy'
import { ContentBlock } from 'common/UI/ContentBlock'
// import ShutDown from 'modules/Auth/ShutDown'

import styles from './App.module.scss'

const App = lazyWithErrorHandling(() => import('./App'))

const ErrorCatcher = () => {
  return (
    <HelmetProvider>
      <ErrorBoundary componentName="MainApp">
        <App />
        {/* <ShutDown /> */}
      </ErrorBoundary>
    </HelmetProvider>
  )
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Suspense
    fallback={
      <ContentBlock className={styles.themeWrapper}>
        <ChatScreenSkeleton />
      </ContentBlock>
    }
  >
    <ThemeProvider>
      <ErrorCatcher />
    </ThemeProvider>
  </Suspense>
)
